import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown, Input } from 'component-library';
import { useEffect, useMemo, useState } from 'react';
import { ConversionMeter } from '../../../../helpers/Custom';
import { ValidPositiveNumber } from '../../../../helpers/Validation';
import { BoatModel } from '../../../../models/ApiModels';

type Props = {
  boatModel: BoatModel;
  editMode: boolean;
  setUpdateBoatModel: (boatModel: BoatModel) => void;
  updateBoatModel: BoatModel;
  isMetric: boolean;
  setIsMetric: (value: boolean) => void;
  setIsValid: (value: boolean) => void;
  userPrefersImperial: boolean;
};

function Beam(props: Props) {
  const [inputBeam, setInputBeam] = useState<number>(props.boatModel.beam ? props.boatModel.beam : 0);

  useEffect(() => {
    props.setIsMetric(!props.userPrefersImperial);
  }, [props.userPrefersImperial]);

  function CheckIsMetric(id: string) {
    if (id === 'meter') {
      props.setIsMetric(true);
      return props.isMetric;
    } else if (id === 'foot') {
      props.setIsMetric(false);
      return props.isMetric;
    }
  }

  useEffect(() => {
    if (props.updateBoatModel.beam !== undefined) {
      setInputBeam(ConversionMeter(props.updateBoatModel.beam, props.isMetric));
    }
  }, [props.updateBoatModel.beam, props.isMetric]);

  const validBeam = useMemo(
    () => ValidPositiveNumber(props.updateBoatModel.beam) || props.updateBoatModel.beam === 0,
    [props.updateBoatModel.beam]
  );

  useEffect(() => {
    if (validBeam) props.setIsValid(true);
    else props.setIsValid(false);
  }, [validBeam]);

  return (
    <div className='flex justify-between py-5 items-center'>
      <span>Beam</span>
      {props.editMode ? (
        <div className='flex gap-2'>
          <Input
            size='Small'
            type='number'
            value={inputBeam === 0 ? '' : inputBeam}
            onChange={(input: number) => setInputBeam(input)}
            onBlur={(input: number) => {
              props.updateBoatModel.beam = ConversionMeter(input, props.isMetric);
              props.setUpdateBoatModel({ ...props.updateBoatModel });
            }}
          />
          <Dropdown
            size='Medium'
            label=''
            optionsData={[
              { id: 'meter', value: 'Meter' },
              { id: 'foot', value: 'Foot' },
            ]}
            placeholder='Meter'
            value={props.isMetric ? 'Meter' : 'Foot'}
            onValueChosen={(id: string) => CheckIsMetric(id)}
          />
        </div>
      ) : (
        <span className={`${!props.boatModel.beam && 'italic'}`}>
          {props.boatModel.beam ? (
            ConversionMeter(props.boatModel.beam, !props.userPrefersImperial, true)
          ) : (
            <div className='text-warning-100'>
              <FontAwesomeIcon icon={faTriangleExclamation} /> <span className='text-gray-40'>Not added</span>
            </div>
          )}
        </span>
      )}
    </div>
  );
}

export default Beam;
